import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-slate-950 text-center">
      <h1 className="text-4xl font-bold text-slate-100">404</h1>
      <p className="text-slate-500">Page not found.</p>
      <Link to="/" className="text-sm text-emerald-400 hover:underline">
        Back to dashboard
      </Link>
    </div>
  );
}
